import { createContext } from 'react'

export const ProductDetailContext = createContext([])